import Vue from "vue";
import VueRouter from "vue-router";
import Clipboard from 'v-clipboard'
import vueCountryRegionSelect from 'vue-country-region-select'

Vue.use(vueCountryRegionSelect)
Vue.use(VueRouter);
Vue.use(Clipboard);

const routes = [
    {
        path: "/:company_username",
        name: "booking_widget",
        component: () => import("../views/AppointmentBookingWidget.vue"),
    },
    {
        path: "/:lang/:company_username",
        name: "booking_widget_with_lang",
        component: () => import("../views/AppointmentBookingWidget.vue")
    }
];

const routerWidget = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    linkActiveClass: "active", // active class for non-exact links.
    linkExactActiveClass: "active", // active class for *exact* links.
    routes
});

export default routerWidget;
